import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LocalizedLink from "../LocalizedLink/LocalizedLink";
import MobileMenu from "../MobileMenu/MobileMenu";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";
import Logo from "../../images/logo.svg";
import { connect } from "react-redux";
import { removeFromCart } from "../../store/actions/action";

// Nav items: stable ids/hrefs; titles are resolved from the `navbar` namespace.
const NAV_ITEMS = [
  { id: 1, href: "/", key: "home" },
  { id: 2, href: "/event", key: "events" },
  { id: 3, href: "/service", key: "services" },
  { id: 4, href: "/about", key: "about" },
  { id: 5, href: "/blog", key: "blog" },
  { id: 6, href: "/contact", key: "contact" },
];

const Header = (props) => {
  const location = useLocation();
  const { t } = useTranslation("navbar");

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const navigation = useMemo(() => {
    // pathname is `/:lang/segment/...`; compare the segment after the lang.
    const seg = location.pathname.split("/")[2] || "";
    return NAV_ITEMS.map((item) => ({
      ...item,
      title: t(item.key),
      current: seg === item.href.split("/")[1],
    }));
  }, [location, t]);
  return (
    <header id="header" className={props.hclass}>
      <div className="wpo-site-header">
        <nav className="navigation navbar navbar-expand-lg navbar-light">
          <div className="container-fluid">
            <div className="row align-items-center ">
              <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                <MobileMenu />
              </div>
              <div className="col-lg-2 col-md-6 col-6">
                <div className="navbar-header">
                  <LocalizedLink
                    onClick={ClickHandler}
                    className="navbar-brand"
                    to="/home"
                  >
                    <img src={Logo} alt="logo" style={{ maxHeight: "70px" }} />
                  </LocalizedLink>
                </div>
              </div>
              <div className="col-lg-8 col-md-1 col-1">
                <div
                  id="navbar"
                  className="collapse navbar-collapse navigation-holder"
                >
                  <button className="menu-close">
                    <i className="ti-close"></i>
                  </button>
                  <ul className="nav  navbar-nav mb-2 mb-lg-0">
                    {navigation.map((item) => {
                      return (
                        <li key={item.id}>
                          <LocalizedLink
                            onClick={ClickHandler}
                            className={item.current ? "active" : ""}
                            to={item.href}
                          >
                            {item.title}
                          </LocalizedLink>
                        </li>
                      );
                    })}
                  </ul>
                  <LanguageSwitcher className="desktop-lang" />
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};
const mapStateToProps = (state) => {
  return {
    carts: state.cartList.cart,
  };
};

export default connect(mapStateToProps, { removeFromCart })(Header);
